<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#182444"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#182444" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 sm9 md10 text-left>
        <span class="mainHeader">Booth Presidents</span>
      </v-flex>
      <!-------------------------ADD CUSTOMER TO SCHEME----------------------------->
      <v-flex xs12 sm3 md2 class="buttons1" pt-2 pt-sm-0 text-right>
        <v-btn dark color="#182444" @click="adddialog = true" class="buttons1">
          <v-icon small>mdi-plus</v-icon> &nbsp; Add New
        </v-btn>
      </v-flex>
      <!-------------------------LIST OF CUSTOMER IN SCHEME----------------------------->
      <v-flex xs12 py-6 text-left>
        <v-card
          class="rounded-lg"
          elevation="0"
          :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'"
          :flat="$route.name == 'Dashboard' ? true : false"
        >
        <v-layout wrap justify-center>
            <v-flex xs12 v-if="presidentList">
              <v-layout wrap class="table" style="font-size: 16px">
                <v-flex xs12 pa-md-2 v-if="presidentList.length > 0">
                  <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont"><b>S.No.</b></th>
                      <th class="text-left tablefont"><b>Name</b></th>
                      <th class="text-left tablefont"><b>Phone</b></th>
                      <th class="text-left tablefont"><b>Constituency</b></th>
                      <th class="text-left tablefont"><b>Booth</b></th>
                      <th class="text-left tablefont">
                        <b>Age</b>
                      </th>
                      <th class="text-left tablefont">
                        <b>Party</b>
                      </th>
                      <th class="text-left tablefont"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(value, i) in presidentList"
                      :key="i"
                      class="table"
                    >
                      <!-- <td>{{ i + 1 }}</td> -->
                      <td>
                        <span v-if="page == 1">
                          {{ i + 1 }}
                        </span>
                        <span v-else>
                          {{ i + 1 + 20 * (page - 1) }}
                        </span>
                      </td>
                      <td>
                        <span v-if="value.firstname">{{ value.firstname }} {{ value.lastname }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.phone">{{ value.phone }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.assemblyConstituencyId">{{ value.assemblyConstituencyId.name }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.boothId">{{ value.boothId.name }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.age">{{ value.age }}</span>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <span v-if="value.mainPartyId">{{ value.mainPartyId.name }}</span>
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                        <v-layout wrap>
                          <v-flex xs6>
                            <v-icon
                              size="18"
                              color="#182444"
                              style="cursor: pointer"
                              @click="
                                (deletedialog = true), (DeleteId = value._id)
                              "
                              >mdi-delete</v-icon
                            >
                          </v-flex>
                          <v-flex xs6>
                            <v-icon
                              size="18"
                              color="#182444"
                              style="cursor: pointer"
                              @click="calledit(value)"
                              >mdi-pencil</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
                </v-flex>
                <v-flex xs12 v-else pa-4 text-center class="tablefont1"> No data found </v-flex>

              </v-layout>
            
           
            </v-flex>
          </v-layout>
        </v-card>
        <v-layout wrap v-if="presidentList" pt-2>
                <v-flex xs12 v-if="presidentList.length > 0">
                  <v-pagination
                small
                color="#182444"
                total-visible="7"
                v-model="page"
                :length="Pagelength"
              >
              </v-pagination>
                </v-flex>
              </v-layout>
        <v-dialog width="400px" v-model="deletedialog">
          <v-card width="400px" class="pa-2">
            <v-layout wrap justify-center>
              <v-flex xs11 text-center
                ><span style="color: #182444" class="menuhead1"
                  >Delete</span
                ></v-flex
              >
              <v-flex xs1 text-right>
                <v-icon @click="deletedialog = false" color="#182444"
                  >mdi-close-box</v-icon
                ></v-flex
              >
              <v-flex xs8 text-center py-4>
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
            <v-card-text class="pa-4"
              >Are you sure you want to delete this data?
            </v-card-text>
            <v-card-actions class="pt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="#182444"
                class="button1"
                dark
                @click="deleteElection(DeleteId)"
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-------------------------ADD CANDIDATE DIALOG----------------------------->
        <v-dialog width="800px" v-model="adddialog">
          <v-form v-model="addcat" ref="addcat" @submit.prevent>
            <v-card tile width="800px" class="rounded-lg px-4">
              <v-layout wrap justify-center pa-4>
                <v-flex xs11 text-center
                  ><span style="color: #182444" class="menuhead1"
                    >Register Booth President</span
                  ></v-flex
                >
                <v-flex xs1 text-right>
                  <v-icon
                    @click="(adddialog = false),(resetForm())"
                    color="#182444"
                    >mdi-close-box</v-icon
                  ></v-flex
                >
                <v-flex xs8 text-center py-4>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Booth</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                  solo flat class="txtfield2"
                    color="#182444"
                    hide-details
                    dense
                    outlined
                    v-model="BoothId"
                    :items="boothList"
                    label="Select Booth"
                    item-value="_id"
                    item-text="name"
                  >
                  </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Candidate</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                  solo flat class="txtfield2"
                    color="#182444"
                    hide-details
                    dense
                    outlined
                    v-model="aspirantId"
                    :items="candidateList"
                    label="Select Candidate"
                    item-value="_id"
                    item-text="firstname"
                  >
                  </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                 </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Personal Details</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="firstname"
                        outlined
                        dense
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="lastname"
                        outlined
                        dense
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">DOB</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="dob"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dob"
                label="DOB"
                background-color="white"
                outlined
                color="#182444"
                readonly
                hide-details
                clearable
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dob"
              no-title
              scrollable
              @change="$refs.menu2.save(dob)"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- </v-layout>
                <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Age</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Enter Age"
                        v-model="calculatedAge "
                        outlined
                        dense disabled
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="phone"
                        outlined
                        color="#182444"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Caste</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="caste"
                        :items="casteList"
                        label="Choose Caste"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Caste"
                        v-model="caste"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Religion</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="religion"
                        :items="religionList"
                        label="Choose religion"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Religion"
                        v-model="religion"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Education</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="education"
                        :items="educationList"
                        label="Choose Education"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Higher Education"
                        v-model="education"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Address</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Marital Status</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="maritalStatus"
                        :items="marrigeList"
                        label="Choose Marital Status"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Street Address</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Street Address"
                        v-model="address"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Pincode</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="number"
                        label="Enter Pincode"
                        v-model="pincode"
                        outlined
                        :rules="pinRules"
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">District</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter District"
                        v-model="district"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">State</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter State"
                        v-model="state"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Country</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Country"
                        v-model="country"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
              </v-layout>
              <v-layout wrap pb-4 justify-end>
                <v-spacer></v-spacer>
                <v-flex xs3 text-right>
                  <v-layout wrap px-4 justify-end fill-height>
                    <v-flex xs12 text-center align-self-end class="buttons1">
                      <v-btn
                        type="submit"
                        color="#182444"
                        dark
                        block
                        @click="validate()"
                        ><v-icon>mdi-plus</v-icon>Add</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
        </v-dialog>
        <!-------------------------EDIT CANDIDATE DIALOG----------------------------->
        <v-dialog width="800px" v-model="dialogedit">
            <v-form v-model="addcat2" ref="addcat2" @submit.prevent>
              <v-card tile width="800px" class="px-4 py-4 rounded-lg">
                <v-layout wrap justify-center>
                  <v-flex xs11 text-center><span style="color:#182444;" class="menuhead1">Edit Booth President</span></v-flex>
                  <v-flex xs1 text-right>
                    <v-icon
                      @click="(dialogedit = false)"
                      color="#182444"
                      >mdi-close-box</v-icon
                    ></v-flex
                  >
                  <v-flex xs8 text-center py-4 >
                <v-divider></v-divider>
              </v-flex>
                </v-layout>
                <v-layout wrap pb-4>
                <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Booth</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                  solo flat class="txtfield2"
                    color="#182444"
                    hide-details
                    dense
                    outlined
                    v-model="editItem.boothId"
                    :items="boothList"
                    label="Select Booth"
                    item-value="_id"
                    item-text="name"
                  >
                  </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                 </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Personal Details</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> First Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        :rules="[rules.required]"
                        type="text"
                        label="First Name"
                        v-model="editItem.firstname"
                        outlined
                        dense
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Last Name </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="text"
                        label="Last Name"
                        v-model="editItem.lastname"
                        outlined
                        dense
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">DOB</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="editItem.dob"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="editItem.dob"
                label="DOB"
                background-color="white"
                outlined
                color="#182444"
                readonly
                hide-details
                clearable
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="editItem.dob"
              no-title
              scrollable
              @change="$refs.menu2.save(editItem.dob)"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- </v-layout>
                <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Age</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        type="number"
                        label="Enter Age"
                        v-model="editItem.age "
                        outlined
                        dense disabled
                        color="#182444"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Email Address </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        :rules="[rules.email]"
                        type="email"
                        label="Enter Email"
                        v-model="editItem.email"
                        outlined
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5"> Mobile Number </span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Contact"
                        v-model="editItem.phone"
                        outlined
                        color="#182444"
                        :rules="phoneRules"
                        dense
                        type="number"
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Caste</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.caste"
                        :items="casteList"
                        label="Choose Caste"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Caste"
                        v-model="editItem.caste"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Religion</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.religion"
                        :items="religionList"
                        label="Choose religion"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Religion"
                        v-model="editItem.religion"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Gender</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.gender"
                        :items="genderList"
                        label="Choose Gender"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs6>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Higher Education</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.education"
                        :items="educationList"
                        label="Choose Education"
                      ></v-select>
                      <!-- <v-text-field
                        color="#182444"
                        type="text"
                        label="Higher Education"
                        v-model="editItem.education"
                        outlined
                        dense
                        hide-details
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout wrap py-4>
                <v-flex xs12>
                  <v-divider style="border-color:black; !important"></v-divider>
                </v-flex>
              </v-layout>
              <v-layout wrap py-2>
                <v-flex class="subhead3" text-left>Address</v-flex>
              </v-layout>
              <v-layout wrap pb-4>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Marital Status</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        outlined
                        hide-details
                        dense
                        color="#182444"
                        v-model="editItem.maritalStatus"
                        :items="marrigeList"
                        label="Choose Marital Status"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Street Address</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Street Address"
                        v-model="editItem.address"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              <!-- </v-layout>
              <v-layout wrap pb-4> -->
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Pincode</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="number"
                        label="Enter Pincode"
                        v-model="editItem.pincode"
                        outlined
                        :rules="pinRules"
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">District</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter District"
                        v-model="editItem.district"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">State</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter State"
                        v-model="editItem.state"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs4>
                  <v-layout wrap px-4>
                    <v-flex xs12 text-left>
                      <span class="subhead5">Country</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        color="#182444"
                        type="text"
                        label="Enter Country"
                        v-model="editItem.country"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
              </v-layout>
                <v-layout wrap pb-4 justify-end>
                  <v-spacer></v-spacer>
                  <v-flex xs3 text-right>
                    <v-layout wrap px-4 justify-end fill-height>
                      <v-flex xs12 text-center align-self-end class="buttons1">
                        <v-btn
                          type="submit"
                          color="#182444"
                          dark
                          block
                          @click="editPresident()"
                          ><v-icon>mdi-pencil</v-icon>Edit</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      timeout: 2000,
      addcat: false,
      ServerError: false,
      appLoading: false,
      page: 1,
      Pagelength: 1,
      adddialog: false,
      dialogedit: false,
      deletedialog: false,
      msg: "",
      menu3:false,

      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phoneRules: [
        (v) => !!v || "phone is required",
        (v) => (v && v.length <= 10) || "invalid number",
        (v) => (v && v.length >= 10) || "invalid number",
        (v) => /^\d{10}$/.test(v) || "phone number must be a number",
      ],
      pinRules: [
  (v) => !!v || "PIN is required",
  (v) => (v && v.length === 6) || "PIN must be 6 digits",
  // (v) => /^\d{4}$/.test(v) || "PIN must be a number",
],
      firstname: "",
      lastname: "",
      country: "",
      state: "",
      district: "",
      pincode: "",
      address: "",
      phone: "",
      email: "",
      dob: "",
      age: "",
      caste: "",
      religion: "",
      gender: "",
      // aspirantId:"",
      genderList: ["Male", "Female", "Other"],
      subList: ["District", "Block", "Grama"],
      marrigeList: ["Married", "Unmarried", "Other"],
      educationList: ["SSLC / below 10th grade","Higher Secondary","Diploma / Certificate Course","Bachelor's Degree","Master's Degree", "Doctorate (Ph.D.)", "Other"],
      education: "",
      BoothId: "",
      maritalStatus: "",
      constituency: "",
      party: "",
      subParty: "",
      menu2: false,
      boothList: [],
      selectedName: "",
      presidentList: [],
      subpartyList: [],
      partyList: [],
      addcat2:false,
      editItem:{},
      candidateList: [],
      electionNames:["State Legislative Assembly","LokSabha Election","Dist.Panchayat Election","Block Panchayat Election","GramaPanchayat Election"],
      casteList: ["Forward Castes", "Scheduled Castes (SC)", "Scheduled Tribes (ST)","Other Backward Classes (OBC)","General Category","Not Applicable (NA)"],
      religionList: ["Christian", "Hindu", "Muslim","Atheist","Other","Not Applicable (NA)"],
    };
  },

  mounted() {
    this.getData();
    this.getPresident();
    this.getCandidate();
  },
  computed: {
    calculatedAge() {
      if (this.dob) {
        const dob = new Date(this.dob);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
          return age - 1;
        }
        console.log("age==",age)

        return age;
      }
      return '';
    },
  },
  watch: {
    calculatedAge(newAge) {
      if (newAge !== '' && newAge < 18) {
        this.msg="This person is underage"
        this.showsnackbar = true;
        console.log("underage")
      } else {
        console.log(" not underage")
      }
    },
    'editItem.dob': {
      handler(newDob) {
        if (newDob) {
          const dob = new Date(newDob);
          const today = new Date();
          const age = today.getFullYear() - dob.getFullYear();
          const monthDiff = today.getMonth() - dob.getMonth();

          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            this.editItem.age = age - 1;
          } else {
            this.editItem.age = age;
          }
          console.log("age==",this.editItem.age)
          if (this.editItem.age < 18) {
            this.msg="Age cannot be less than 18"
            this.showsnackbar = true;
          } else {
            this.showsnackbar = false;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      this.$refs.addcat.reset();
    },
    validate() {
      if (!this.firstname) {
        this.msg = "Please enter firstname";
        this.showsnackbar = true;
        return;
      } else if (!this.lastname) {
        this.msg = "Please enter lastname";
        this.showsnackbar = true;
        return;
      } else if (!this.gender) {
        this.msg = "Please enter gender";
        this.showsnackbar = true;
        return;
      } else if (!this.phone) {
        this.msg = "Please enter phone";
        this.showsnackbar = true;
        return;
      } else if (!this.email) {
        this.msg = "Please enter email";
        this.showsnackbar = true;
        return;
      } else if (!this.BoothId) {
        this.msg = "Please choose Booth";
        this.showsnackbar = true;
        return;
      }else if (!this.dob) {
        this.msg = "Please enter DOB";
        this.showsnackbar = true;
        return;
      }else if (this.dob && this.calculatedAge<18) {
        this.msg = "Age cannot be less than 18";
        this.showsnackbar = true;
        return;
      }  else {
        this.addPresident();
      }
    },
   addPresident() {
      this.appLoading = true;
      axios({
        url: "/user/boothpresident/add",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          firstname: this.firstname,
          lastname: this.lastname,
          // country: this.country,
          state: this.state,
          district: this.district,
          pincode: this.pincode,
          address: this.address,
          phone: this.phone,
          email: this.email,
          dob: this.dob,
          age: this.calculatedAge,
          caste: this.caste,
          religion: this.religion,
          gender: this.gender,
          education: this.education,
          boothId: this.BoothId,
          maritalStatus: this.maritalStatus,
          // aspirantId:this.aspirantId,

        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;
             this.msg = response.data.msg;
            this.showsnackbar = true;
          this.adddialog = false;
          this.toYear = null;
          this.electionName = null;
          this.fromYear = null;
          this.$refs.addcat.reset();
          this.getPresident();
          
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          this.getPresident();
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/booth/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
          type: "State Legislative Assembly",
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.boothList = response.data.data;
          // this.Pagelength = Math.ceil(response.data.count / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getPresident() {
      this.appLoading = true;
      axios({
        url: "/user/boothpresident/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          limit: 50,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;
            this.presidentList = response.data.data;
          this.Pagelength = Math.ceil(response.data.totalLength / 50);
          
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
         
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getCandidate() {
      this.appLoading = true;
      axios({
        url: "/user/aspirant/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          limit: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.candidateList = response.data.data;
          // this.Pagelength = Math.ceil(response.data.totalLength / 50);
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    getParty() {
      // this.appLoading = true;
      axios({
        url: "/main/politicalparty/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          count: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.partyList = response.data.data;
          this.Pagelength = Math.ceil(response.data.count / 50);
        //   this.getSubParty();
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
    editPresident() {
      if(this.editItem.age<18){
        this.msg="Age cannot be less than 18"
            this.showsnackbar = true;
      }
      else{
      axios({
        url: "/user/edit",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.editItem._id,
          firstname: this.editItem.firstname,
          lastname: this.editItem.lastname,
          // country: this.editItem.country,
          state: this.editItem.state,
          district: this.editItem.district,
          pincode: this.editItem.pincode,
          streetAddress: this.editItem.streetAddress,
          locality: this.editItem.locality,
          city: this.editItem.city,
          phone: this.editItem.phone,
          email: this.editItem.email,
          dob: this.editItem.dob,
          age: this.editItem.age,
          caste: this.editItem.caste,
          religion: this.editItem.religion,
          gender: this.editItem.gender,
          education: this.editItem.education,
          maritalStatus:this.editItem.maritalStatus,
          address:this.editItem.address,
          // electionType: this.editItem.electionType,
          boothId: this.editItem.boothId,
          mainPartyId:this.editItem.mainPartyId,
          subPartyId: this.editItem.subPartyId,
          constituency: this.editItem.constituency,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.dialogedit = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          this.getPresident();
          } else {
          this.msg = response.data.msg;
            this.showsnackbar = true;
          }
         
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
      }
    },
    calledit(item){
      console.log("A")
       this.editItem = item;
      this.dialogedit = true;
      console.log("B")

    },
    deleteElection(id) {
      axios({
        url: "/user/remove",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: id,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.appLoading = false;
            this.deletedialog = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.DeleteId = 0;
            this.getPresident();
          } else {
             this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          //   this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
     <style scoped>
.v-text-field input {
  font-family: kumbhBold;
}

/* Define the red color for the active tab's head background */
.red-tab {
  background-color: white;
}

/* Define the green color for all other tabs' head background */
.green-tab {
  background-color: #f9f6ff;
}

</style>





    